import React from "react";
import styled from "styled-components";
import config from "../config.json";

const Container = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  z-index: 100000;
`;

export default function Restart() {
  return (
    <Container>
      <a href={config.url} target="_blank">
        restart
      </a>
    </Container>
  );
}
